import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, ListGroup, Badge, Button } from 'react-bootstrap';

const RevisionNotes = () => {
  const [revisionData, setRevisionData] = useState(null);

  useEffect(() => {
    // Load the contents.json file
    fetch('/Revision/contents.json')
      .then(response => response.json())
      .then(data => setRevisionData(data))
      .catch(error => console.error('Error loading revision data:', error));
  }, []);

  // Group books by category and subject
  const groupBooksByCategory = (books) => {
    const grouped = {};
    
    books.forEach(book => {
      const category = book.Category === 0 ? 'A2' : 'GCSE';
      const subject = book.Name;
      
      if (!grouped[category]) {
        grouped[category] = {};
      }
      
      if (!grouped[category][subject]) {
        grouped[category][subject] = [];
      }
      
      grouped[category][subject].push(book);
    });
    
    return grouped;
  };

  const getBackgroundColor = (book) => {
    const [r, g, b] = book.BackgroundColor;
    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <Container className="py-5">
      <h1 className="pb-2 mb-4">
        <i className="bi bi-book"></i> Revision Notes
      </h1>
      
      <Row>
        <Col lg={8}>
          <h2 className="mb-4">Subject Notes</h2>
          {revisionData ? (
            Object.entries(groupBooksByCategory(revisionData.Books)).map(([category, subjects]) => (
              <Card key={category} className="mb-4">
                <Card.Header>
                  <h5 className="mb-0 fw-bold">{category} Level</h5>
                </Card.Header>
                <Card.Body>
                  {Object.entries(subjects).map(([subject, books]) => (
                    <div key={subject} className="mb-3">
                      <h6 className="fw-bold text-primary">{subject}</h6>
                      <ListGroup variant="flush">
                        {books.map((book, index) => (
                          <ListGroup.Item 
                            key={index} 
                            className="d-flex justify-content-between align-items-center"
                            style={{ 
                              borderLeft: `4px solid ${getBackgroundColor(book)}`,
                              backgroundColor: `${getBackgroundColor(book)}20`
                            }}
                          >
                            <div>
                              <span className="fw-medium">{book.Detail}</span>
                              <br />
                              <small className="text-muted">
                                {book.Name} - {book.Author}
                              </small>
                            </div>
                            <div>
                              {book.Total > 1 && (
                                <Badge bg="primary" className="me-2">
                                  Part {book.Index} of {book.Total}
                                </Badge>
                              )}
                              <Button 
                                variant="outline-success" 
                                size="sm"
                                href={`/Revision${book.SourceUrl}`}
                                target="_blank"
                              >
                                View PDF
                              </Button>
                            </div>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    </div>
                  ))}
                </Card.Body>
              </Card>
            ))
          ) : (
            <div className="text-center py-4">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading revision notes...</p>
            </div>
          )}
        </Col>
        
        <Col lg={4}>
          <h2 className="mb-4">YouTube Tutorials</h2>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title as="h6" className="mb-3">
                <i className="bi bi-youtube text-danger"></i> Coding with Ronaldo
              </Card.Title>
              <div className="ratio ratio-16x9 mb-3">
                <iframe 
                  src="https://www.youtube.com/embed/sHxSJJt6OKQ?si=Zd29hFzrKX4-StQ5" 
                  title="Coding with Ronaldo YouTube Channel"
                  allowFullScreen
                ></iframe>
              </div>
              <p className="small text-muted mb-3">
                Watch my tech tutorials on YouTube.
              </p>
              <a 
                href="https://www.youtube.com/@codingwithronaldo4496/videos" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-danger btn-sm w-100"
              >
                <i className="bi bi-youtube"></i> Visit Channel
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Card className="border-success">
            <Card.Body>
              <h4 className="text-success">Note</h4>
              <p className="mb-0">
                These revision notes are continuously updated as I learn new concepts and technologies. 
                Feel free to reach out if you have questions about any specific topics or would like 
                to contribute additional resources.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RevisionNotes; 